import { useEffect } from 'react'
import { usePopUpMembershipStore } from '../stores/pop-up-membership-store'
import { useAccount } from '../../../hooks/useAccount'
import { useAnnouncementStore } from '../../announcement/hooks/use-announcement-store'

export function useMembershipNotification() {
  const { isLogin, account } = useAccount()

  const { popupShown, status, setStatus, markPopupShown, resetPopup } =
    usePopUpMembershipStore()

  const { forceShowNext } = useAnnouncementStore.getState()

  // Reset jika logout
  useEffect(() => {
    if (!isLogin) {
      resetPopup()
    }
  }, [isLogin, resetPopup])

  // Hitung status membership
  useEffect(() => {
    if (!isLogin) return
    if (!account || !account.dateExpired) return
    if (popupShown) return

    const now = new Date()
    const exp = new Date(account.dateExpired)
    const diffDays = Math.ceil((exp - now) / (1000 * 60 * 60 * 24))

    if (diffDays <= 0) setStatus('expired')
    else if (diffDays <= 7) setStatus('warning')
  }, [isLogin, account, popupShown, setStatus])

  const shouldShow = !popupShown && Boolean(status)

  const onClose = () => {
    markPopupShown()
    forceShowNext() // aman karena shownIds belum terisi
  }

  return {
    account,
    shouldShow,
    status,
    onClose,
  }
}
